"use client";

import React from "react";
import { ArrowRight, Lightbulb, Target } from "lucide-react";
import { Bar, BarChart, CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent, type ChartConfig } from "@/components/ui/chart";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const caseStudies = [{
  id: "cs-1",
  title: "Law Experience",
  challenge: "After graduating from University of Michigan I joined a small law firm to gain experience and apply to law schools. While there I worked in litigation and specifically in personal injury suits. While with the firm I built background for cases and assisted in building arguments. In that time I would come to discover that the law field was not for me.",
  solution: "Developed a comprehensive market segmentation model and competitive analysis framework, identifying high-growth niches for targeted digital acquisition and localized brand positioning.",
  metricLabel: "Actual Growth vs. Projected Target (%)",
  chartType: "bar",
  link: "#"
}, {
  id: "cs-2",
  title: "Automotive",
  challenge: "After departing the law firm I took a job in the automotive field in the operations department my duties included scheduling supply deliveries and work schedules. In this time I built more real world working experience and worked to find out where I was planning to go in my life. I often still assist in some duties with the company working remote.\xA0\xA0",
  solution: "Implemented an integrated strategic management platform and standardized reporting protocols, fostering a culture of transparency and increasing cross-functional collaboration efficiency.",
  metricLabel: "Operational Efficiency Index (Annualized)",
  chartType: "line",
  link: "#"
}];
const chartData1 = [{
  quarter: "Q1",
  revenue: 85,
  target: 100
}, {
  quarter: "Q2",
  revenue: 110,
  target: 115
}, {
  quarter: "Q3",
  revenue: 165,
  target: 135
}, {
  quarter: "Q4",
  revenue: 240,
  target: 160
}];
const chartConfig1 = {
  revenue: {
    label: "Actual Growth",
    color: "var(--chart-1)"
  },
  target: {
    label: "Projected Target",
    color: "var(--chart-2)"
  }
} satisfies ChartConfig;
const chartData2 = [{
  month: "Jan",
  share: 12
}, {
  month: "Mar",
  share: 25
}, {
  month: "Jun",
  share: 48
}, {
  month: "Sep",
  share: 62
}, {
  month: "Dec",
  share: 88
}];
const chartConfig2 = {
  share: {
    label: "Efficiency Index (%)",
    color: "var(--chart-1)"
  }
} satisfies ChartConfig;
export default function CaseStudies() {
  return <section data-section-id="148952" id="working-career" className="dark bg-background text-foreground w-full">
      {caseStudies.map((study, index) => <div key={study.id} data-index={index} className={`min-h-[80vh] flex flex-col justify-center py-24 border-b border-border/10 last:border-0 ${index % 2 !== 0 ? "bg-muted/5" : "bg-background"}`}>
          <div className="container mx-auto px-6 md:px-12 lg:px-24">
            <div className="grid lg:grid-cols-12 gap-16 items-center">
              
              {}
              <div className="lg:col-span-5 space-y-12">
                <div>
                  
                  <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight leading-tight text-foreground">
                    {study.title}
                  </h2>
                </div>

                <div className="space-y-8 relative before:absolute before:inset-y-0 before:left-0 before:w-px before:bg-border/30 pl-8">
                  <div className="relative">
                    
                    
                    <p className="text-muted-foreground leading-relaxed font-sans !w-[400px]">
                      {study.challenge}
                    </p>
                  </div>

                  <Separator className="bg-border/20" />

                  <div className="relative">
                    
                    
                    
                  </div>
                </div>

                <div className="pt-4">
                  <Button asChild variant="outline" className="rounded-none border-primary/40 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-sm hover:shadow-lg">
                    
                  </Button>
                </div>
              </div>

              {}
              <div className="lg:col-span-7">
                
              </div>

            </div>
          </div>
        </div>)}
    </section>;
}